import * as React from "react";
import { Typography, Box } from "@mui/material";
import { ResponsiveContainer } from "@/components/dashboard/ResponsiveContainer";
import { InformationGrid } from "@/components/dashboard/InformationGrid";
import { PerformanceSummarySection } from "@/components/analytics/sections/PerformanceSummarySection";
import { PerformanceMetricsSection } from "@/components/analytics/sections/PerformanceMetricsSection";
import { RiskMetricsSection } from "@/components/analytics/sections/RiskMetricsSection";
import { AnalyticsSystemInformationSection } from "@/components/analytics/sections/AnalyticsSystemInformationSection";

export function AnalyticsPage(): React.JSX.Element {
  return (
    <ResponsiveContainer>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Analytics
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Backend-reported analytics only — no metrics are calculated in the frontend.
        </Typography>
      </Box>
      <InformationGrid>
        <PerformanceSummarySection />
        <PerformanceMetricsSection />
        <RiskMetricsSection />
        <AnalyticsSystemInformationSection />
      </InformationGrid>
    </ResponsiveContainer>
  );
}
